export const primary = "#8db1a5";
export const secondary = "#f4dfdc";

export const orderDone = "#aaaaaa";
export const newOrder = "#000000";
export const orderInProgress = "#d68b4f";
